import React, {createRef, useEffect, useRef, useState} from 'react';
import './button.css'
import {findDOMNode} from "react-dom";
import useIsMountedRef from "../../utils/mountedRef";


// example of using the component: <ButtonYesno handleChange={handleChange} setter={setActeEnMain} onlyTrueFalse={true}/>

const ButtonTextCautio = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const isMountedRef = useIsMountedRef();

    const refSameActe = createRef();
    const refSplitActe = createRef();
    let [currentRef, setCurrentRef] = useState(null)

    function EventClick(refPassed, value) {

        refPassed.current.classList.remove("item_no_selected");

        if (refPassed !== refSameActe) {
            refSameActe.current.classList.remove('item_selected')
            refSameActe.current.classList.add('item_no_selected')
        }

        if (refPassed !== refSplitActe) {
            refSplitActe.current.classList.remove('item_selected')
            refSplitActe.current.classList.add('item_no_selected')
        }

        refPassed.current.classList.add('item_selected')

        setCurrentRef(refPassed);
        setSelectedValue(value);      
        refPassed.current.focus(); 
        props.handleChange(props.setter, value) // launch handleChange in parent simu
    }
    const handleKeyDown = (e, currentIndex) => {
    const buttons = [refSplitActe, refSameActe]; 

        if (e.key === "ArrowRight") {
            e.preventDefault();
            if (currentIndex < buttons.length - 1) {
                const next = buttons[currentIndex + 1];
                next.current.focus();
                EventClick(next, parseInt(next.current.dataset.value));
            }
        } 
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (currentIndex > 0) {
                const prev = buttons[currentIndex - 1];
                prev.current.focus();
                EventClick(prev, parseInt(prev.current.dataset.value));
            }
        }
    };


    useEffect(() => {
        switch (props.defaultValue) {
            case 0:
                EventClick(refSplitActe, 1);
                break;
            case 1:
                EventClick(refSameActe, 0);
                break;
            default:
                break;
        }
    }, [isMountedRef]);

    return (
        <div className={"item_ctn"}>

            <button data-value="1" className={"common item_no_selected item_large"} ref={refSplitActe} 
            tabIndex={selectedValue === 1 ? 0 : -1}
            onClick={() => {
                EventClick(refSplitActe, 1)
            }}
            onKeyDown={(e) => handleKeyDown(e, 0)}>
                Par acte séparé
            </button>

            <button data-value="0" className={"common item_no_selected item_large"} ref={refSameActe} 
            tabIndex={selectedValue === 0 ? 0 : -1}
            onClick={() => {
                EventClick(refSameActe, 0)
            }}
            onKeyDown={(e) => handleKeyDown(e, 1)}>
                Dans l'acte principal
            </button>
        </div>
    );
};

export default ButtonTextCautio;
